import React from 'react'

import { Space, Alert } from 'antd'

const SiteHeader = () => {
  const rules = (
    <ol style={{ margin: 0, paddingLeft: 18 }}>
      <li>Guess if the next card drawn will be higher or lower</li>
      <li>Aces are high for card sharks</li>
      <li>Try to get as many correct guesses in a row</li>
    </ol>
  )

  // 🔴 A <section>, NOT A <header>. There is now exactly one <header> on this page and it
  // is the house bar (TopBar.js, standard part 3). This block is the game's own hero — the
  // heading, the tagline and the rules — which is content rather than chrome, and leaving it
  // as a second <header> made "the header" mean two different things to any tool that asks
  // for it (the compliance check's own render pass asks, and counted this one).
  return (
    <section className='dvs-header'>
      <h1 className='dvs-eyebrow'><span className='dot' />Card sharks</h1>
      <p className='dvs-tagline'>Beat your best streak.</p>
      <Space direction='vertical' size='middle' style={{ width: '100%', maxWidth: 560, margin: '20px auto 0', textAlign: 'left' }}>
        <Alert type='success' closable message='Rules' description={rules} />
        <Alert type='warning' closable message='Your high score is saved unless you refresh the page.' />
      </Space>
    </section>
  )
}

export default SiteHeader
